import React from 'react';
import { Card, IconButton } from '../../../atoms';
import { CardContent } from '@mui/material';
import { cx } from '@emotion/css';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ReportRoundedIcon from '@mui/icons-material/ReportRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CloseIcon from '@mui/icons-material/Close';
import { ix } from '../../../../utils/ix';
import { Typography } from '../../../electrons';
import useStyles from './AlertV2.styles';
import { DEFAULT_TYPOGRAPHY_VARIANT } from './AlertV2.constants';
export function AlertV2(props) {
    const { children, title, className, id, variant, typographyVariant, onClose, } = props;
    const classes = useStyles(Object.assign(Object.assign({}, props), { typographyVariant: typographyVariant || DEFAULT_TYPOGRAPHY_VARIANT }));
    const variantClassName = variant ? { [variant]: true } : {};
    const renderIcon = () => {
        switch (variant) {
            case 'success':
                return React.createElement(CheckCircleRoundedIcon, null);
            case 'error':
                return React.createElement(ReportRoundedIcon, null);
            case 'info':
                return React.createElement(InfoRoundedIcon, null);
            case 'warning':
                return React.createElement(WarningRoundedIcon, { color: "warning" });
        }
    };
    return (React.createElement(Card, { variant: "outlined", className: cx(className, classes.root, variant ? { [variant]: true } : {}), id: id },
        React.createElement(CardContent, { className: cx(classes.content, variant ? { [variant]: true } : {}) },
            React.createElement("div", { className: classes.titleContainer },
                React.createElement("span", { className: cx(classes.iconWrapper, variantClassName) }, renderIcon()),
                React.createElement("div", null,
                    React.createElement(Typography, { id: ix(props.id, 'title'), variant: "h5" }, title),
                    children),
                onClose && (React.createElement(IconButton, { "aria-label": "close", id: ix(props.id, 'icon-button'), onClick: onClose, className: classes.closeButton },
                    React.createElement(CloseIcon, { className: classes.closeIcon })))))));
}
//# sourceMappingURL=AlertV2.js.map